<template>
    <div class="custom-work-executive-entry">
        <mt-input label="Name" v-model="name" :errorMessage="nameError" />
        <mt-input label="Title" v-model="title" :errorMessage="titleError" />
        <mt-input label="Company" v-model="company" :errorMessage="companyError" />
        <mt-input label="Ticker" v-model="symbol" />
        <div class="button-group">
            <button class="secondary" @click="cancel">Cancel</button>
            <button class="primary" @click="commit">Add</button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        initialName: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            name: this.initialName,
            title: '',
            company: '',
            symbol: '',
            showErrors: false,
        }
    },
    watch: {
        initialName() {
            this.name = this.initialName
        },
    },
    computed: {
        hasCompanyError() {
            return this.company.trim() === ''
        },
        hasErrors() {
            return this.hasCompanyError || this.hasNameError || this.hasTitleError
        },
        hasNameError() {
            return this.name.trim() === ''
        },
        hasTitleError() {
            return this.title.trim() === ''
        },
        companyError() {
            return this.showErrors && this.hasCompanyError ? 'Company is required' : ''
        },
        nameError() {
            return this.showErrors && this.hasNameError ? 'Name is required' : ''
        },
        titleError() {
            return this.showErrors && this.hasTitleError ? 'Title is required' : ''
        },
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        commit() {
            this.showErrors = true

            if (!this.hasErrors) {
                this.$emit('commit', {
                    colloquialName: this.name,
                    position: this.title,
                    currentCompany: { name: this.company, symbol: this.symbol },
                })

                this.showErrors = false
            }
        },
    },
}
</script>
